export default function ServicesGrid() {
  const services = [
    {
      href: "/reglage-fenetre-oscillo-battant",
      icon: "ri-settings-4-line",
      title: "Réglage oscillo-battant",
      desc: "Fenêtre oscillo-battant qui déraille ou ne ferme plus ? Réglage précis des ciseaux et des galets.",
    },
    {
      href: "/fenetre-oscillo-battant-bloquee",
      icon: "ri-lock-line",
      title: "Oscillo-battant bloqué",
      desc: "Fenêtre bloquée en mode oscillo ou battant ? Déblocage et réparation du mécanisme.",
    },
    {
      href: "/cremone-fenetre",
      icon: "ri-key-line",
      title: "Crémone de fenêtre",
      desc: "Crémone cassée ou bloquée ? Remplacement du mécanisme de verrouillage à domicile.",
    },
    {
      href: "/poignee-fenetre-bloquee",
      icon: "ri-door-open-line",
      title: "Poignée de fenêtre",
      desc: "Poignée qui tourne dans le vide ou bloquée ? Changement de la poignée et de l'axe.",
    },
    {
      href: "/gond-paumelle-fenetre",
      icon: "ri-hammer-line",
      title: "Gond & paumelle",
      desc: "Fenêtre qui s'affaisse ou frotte ? Remplacement des gonds et paumelles usés.",
    },
    {
      href: "/fenetre-ferme-mal",
      icon: "ri-draft-line",
      title: "Fenêtre qui ferme mal",
      desc: "Fenêtre qui force, ne verrouille plus ou laisse passer l'air ? Réparation et réglage.",
    },
    {
      href: "/fenetre-pvc",
      icon: "ri-window-line",
      title: "Fenêtre PVC",
      desc: "Toutes pannes sur fenêtre PVC : crémone, poignée, oscillo-battant, gond, réglage.",
    },
    {
      href: "/fenetre-alu",
      icon: "ri-building-line",
      title: "Fenêtre Aluminium",
      desc: "Réparation mécanique sur fenêtre aluminium : ferrures, joints, réglage, compression.",
    },
    {
      href: "/fenetre-bois",
      icon: "ri-tree-line",
      title: "Fenêtre Bois",
      desc: "Fenêtre en bois qui gonfle ou dont le mécanisme est bloqué ? Réparation à domicile.",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6 text-center">
            Toutes nos prestations de réparation
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-10 md:mb-14 text-center max-w-3xl mx-auto">
            Quelle que soit la panne sur votre fenêtre, nos techniciens interviennent chez vous en une seule visite dans tout le Bas-Rhin. Déplacement et diagnostic gratuits, pièce comprise, garantie 10 ans.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {services.map((service) => (
              <a
                key={service.href}
                href={service.href}
                className="group bg-white rounded-2xl p-5 md:p-6 border border-rose-100 hover:border-coral/30 transition-colors flex flex-col"
              >
                <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-coral/10 transition-colors">
                  <i className={`${service.icon} text-plum text-xl group-hover:text-coral transition-colors`} />
                </div>
                <h3 className="font-semibold text-base md:text-lg text-plum-dark mb-2 group-hover:text-coral transition-colors">
                  {service.title}
                </h3>
                <p className="text-sm md:text-base text-plum-dark/70 leading-relaxed flex-1">
                  {service.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-coral mt-4">
                  Voir la prestation
                  <i className="ri-arrow-right-line" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}